import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';
import { NavItem } from '../interfaces/nav-item.interface';
import { UserRoles } from '../enums/user-roles.enum';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor(private userService: UserService) {}

  async getMenuItems(mobile: boolean = false) {
    return new Promise<NavItem[]>(async (resolve) => {
      this.userService.getUser().then((value: any) => {
        value.subscribe((user: any) => {
          let community_shop = false;
          let promotions = false;
          let articles = false;
          if (user != null) {
            community_shop = user.roles.indexOf(this.userService.ROLE_VIEW_COMMUNITY_SHOP) > -1;
            promotions = user.roles.indexOf(UserRoles.ROLE_VIEW_PROMOTIONS) > -1;

            if(user.roles.indexOf(UserRoles.ROLE_MANAGE_PARTNER) > -1) {
              community_shop = true;
              promotions = true;
            }
            if(user.roles.indexOf(UserRoles.ROLE_VIEW_ITEMS_PERMANENTS) > -1) {
              articles = true;
            }
          }
          if (!environment.menu) {
            let newMenu: NavItem[] = [
              ...(articles
                ? [
                  {
                    index: 0,
                    label: 'menu.articles',
                    icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Articoli-Nav.svg',
                    url: '/articles',
                    children: [
                      {
                        label: 'menu.permanent',
                        url: '/articles/permanent',
                        viewPermissions: [UserRoles.ROLE_VIEW_ITEMS_PERMANENTS]
                      },
                    ],
                  },
                  ]
                : []),


              ...(promotions
                ? [
                    {
                      index: 1,
                      label: 'menu.promotion',
                      viewPermissions: [UserRoles.ROLE_VIEW_PROMOTIONS],
                      icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Promozioni-Nav.svg',
                      url: '/promotion',
                      children: [
                        {
                          label: 'menu.discounts',
                          url: '/promotion/discounts',
                        },
                      ],
                    },
                  ]
                : []),
              ...(community_shop
                ? [
                    {
                      index: 8,
                      label: 'menu.community',
                      viewPermissions: [UserRoles.ROLE_VIEW_COMMUNITY_SHOP],
                      icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Omnichannel-Nav.svg',
                      url: '/community',
                      children: [
                        {
                          label: 'menu.catalog',
                          url: '/community/shop',
                        },
                        {
                          label: 'menu.orders',
                          url: '/community/order',
                        },
                      ],
                    },
                  ]
                : []),
              {
                index: 2,
                label: 'menu.logout',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Logout-Nav.svg',
                url: '#',
                action: 'LOGOUT',
              },
            ];

            /*  TODO: refactor filter menu based on user roles
           newMenu = newMenu.filter((item) => {

              return item.viewPermissions?.filter((viewPermission) => this.userService.hasRole(viewPermission));

            }); */

            resolve(newMenu);
          } else {
            let debugMenu: NavItem[] = [
              {
                index: 0,
                label: 'menu.articles',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Articoli-Nav.svg',
                url: '/articles',
                children: [
                  {
                    label: 'menu.entities',
                    url: '/articles/entities',
                  },
                  {
                    label: 'menu.association',
                    url: '/articles/association',
                  },
                  {
                    label: 'menu.catalog',
                    url: '/articles/catalog',
                  },
                  {
                    label: 'menu.permanent',
                    url: '/articles/permanent',
                    viewPermissions: [UserRoles.ROLE_VIEW_ITEMS_PERMANENTS]
                  },
                  {
                    label: 'menu.transfer',
                    url: '/articles/transfer',
                    viewPermissions: [UserRoles.ROLE_MANAGE_ADMIN],
                  },
                ],
              },
              {
                index: 1,
                label: 'menu.orders',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Orders-Nav.svg',
                url: '/orders',
                children: [
                  {
                    label: 'menu.toconfirm',
                    url: '/orders/toconfirms',
                  },
                  {
                    label: 'menu.tosend',
                    url: '/orders/tosend',
                  },
                  {
                    label: 'menu.nostock',
                    url: '/orders/nostocks',
                  },
                  {
                    label: 'menu.returns',
                    url: '/orders/returns',
                  },
                ],
              },
              {
                index: 2,
                label: 'menu.accounting',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Contabilita-Nav.svg',
                url: '/accounting',
                children: [
                  {
                    label: 'menu.newdocument',
                    url: '#',
                    opened: false,
                    children: [
                      {
                        label: 'menu.revieworders',
                        url: 'accounting/new-document/create-invoice',
                      },
                      {
                        label: 'menu.reviewreturn',
                        url: 'accounting/new-document/create-credit-memo',
                      },
                      {
                        label: 'menu.ddt',
                        url: 'accounting/new-document/create-return-document',
                      },
                      {
                        label: 'menu.shipping',
                        url: 'accounting/new-document/create-shipping-fee',
                      },
                    ],
                  },
                  {
                    label: 'menu.accountingrecords',
                    url: 'accounting/accounting-records',
                  },
                ],
              },
              {
                index: 3,
                label: 'menu.logistics',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Vendite-Nav.svg',
                url: '/logistics',
              },
              {
                index: 4,
                label: 'menu.partner',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Partner-Nav.svg',
                url: '/partner',
              },
              {
                index: 5,
                label: 'menu.promotion',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Promozioni-Nav.svg',
                url: '/promotion',
                children: [
                  {
                    label: 'menu.discounts',
                    url: '/promotion/discounts',
                  },
                  {
                    label: 'menu.businesscalendar',
                    url: '/promotion/business-calendar',
                  },
                ],
              },
              {
                index: 8,
                label: 'menu.community',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Omnichannel-Nav.svg',
                url: '/community',
                children: [
                  {
                    label: 'menu.catalog',
                    url: '/community/shop',
                  },
                  {
                    label: 'menu.orders',
                    url: '/community/order',
                  },
                ],
              },
              {
                index: 7,
                label: 'menu.logout',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Logout-Nav.svg',
                url: '#',
                action: 'LOGOUT',
              },
            ];
            //TODO: filter based on viewpermissions
 /*            debugMenu = debugMenu.filter((item) => {
              if(!item.viewPermissions) {
                return item;
              } else {
                return item.viewPermissions?.filter((viewPermission) => this.userService.hasRole(viewPermission));
              }

             });
 */
            resolve(debugMenu);
          }
        });
      });
    });
  }

  getMobileMenuItems() {
    return this.getMenu(true);
  }

  async getMenu(mobile: boolean = false) {
    return new Promise<NavItem[]>(async (resolve) => {
      this.userService.getUser().then((value: any) => {
        value.subscribe((user: any) => {
          let boutique = false;
          let articles = false;
          if (user != null) {
            boutique = user.roles.indexOf(this.userService.ROLE_VIEW_BOUTIQUE) > -1;
            console.log(user.roles.indexOf(this.userService.ROLE_VIEW_BOUTIQUE) > -1);
          }
          if(user.roles.indexOf(UserRoles.ROLE_VIEW_ITEMS_PERMANENTS) > -1) {
            articles = true;
          }
          if (!environment.menu) {
            let newMenu: NavItem[] = [
              ...(articles
                ? [
                  {
                    index: 0,
                    label: 'menu.articles',
                    icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Articoli-Nav.svg',
                    url: '/articles',
                    children: [
                      {
                        label: 'menu.permanent',
                        url: '/articles/permanent',
                        viewPermissions: [UserRoles.ROLE_VIEW_ITEMS_PERMANENTS]
                      },
                    ],
                  },
                  ]
                : []),

              {
                index: 1,
                label: 'menu.promotion',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Promozioni-Nav.svg',
                url: '/promotion',
                children: [
                  {
                    label: 'menu.discounts',
                    url: '/promotion/discounts',
                  },
                ],
              },
              {
                index: 2,
                label: 'menu.logout',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Logout-Nav.svg',
                url: '#',
                action: 'LOGOUT',
              },
              ...(boutique
                ? [
                    {
                      index: 8,
                      label: 'menu.community',
                      icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Omnichannel-Nav.svg',
                      url: '/community',
                      children: [
                        {
                          label: 'menu.catalog',
                          url: '/community/shop',
                        },
                        {
                          label: 'menu.orders',
                          url: '/community/order',
                        },
                      ],
                    },
                  ]
                : []),
            ];

            console.log(newMenu, boutique);

            resolve(newMenu);
          } else {
            resolve([
              {
                index: 0,
                label: 'menu.articles',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Articoli-Nav.svg',
                url: '/articles',
                children: [
                  {
                    label: 'menu.entities',
                    url: '/articles/entities',
                  },
                  {
                    label: 'menu.association',
                    url: '/articles/association',
                  },
                  {
                    label: 'menu.catalog',
                    url: '/articles/catalog',
                  },
                ],
              },
              {
                index: 1,
                label: 'menu.orders',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Orders-Nav.svg',
                url: '/orders',
                children: [
                  {
                    label: 'menu.toconfirm',
                    url: '/orders/toconfirms',
                  },
                  {
                    label: 'menu.tosend',
                    url: '/orders/tosend',
                  },
                  {
                    label: 'menu.nostock',
                    url: '/orders/nostocks',
                  },
                  {
                    label: 'menu.returns',
                    url: '/orders/returns',
                  },
                ],
              },
              {
                index: 2,
                label: 'menu.accounting',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Contabilita-Nav.svg',
                url: '/accounting',
                children: [
                  {
                    label: 'menu.newdocument',
                    url: '#',
                    opened: false,
                    children: [
                      {
                        label: 'menu.revieworders',
                        url: 'accounting/new-document/create-invoice',
                      },
                      {
                        label: 'menu.reviewreturn',
                        url: 'accounting/new-document/create-credit-memo',
                      },
                      {
                        label: 'menu.ddt',
                        url: 'accounting/new-document/create-return-document',
                      },
                      {
                        label: 'menu.shipping',
                        url: 'accounting/new-document/create-shipping-fee',
                      },
                    ],
                  },
                  {
                    label: 'menu.accountingrecords',
                    url: 'accounting/accounting-records',
                  },
                ],
              },
              {
                index: 3,
                label: 'menu.logistics',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Vendite-Nav.svg',
                url: '/logistics',
              },
              {
                index: 4,
                label: 'menu.partner',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Partner-Nav.svg',
                url: '/partner',
              },
              {
                index: 5,
                label: 'menu.promotion',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Promozioni-Nav.svg',
                url: '/promotion',
                children: [
                  {
                    label: 'menu.discounts',
                    url: '/promotion/discounts',
                  },
                  {
                    label: 'menu.businesscalendar',
                    url: '/promotion/business-calendar',
                  },
                ],
              },
              {
                index: 8,
                label: 'menu.community',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Omnichannel-Nav.svg',
                url: '/community',
                children: [
                  {
                    label: 'menu.catalog',
                    url: '/community/shop',
                  },
                  {
                    label: 'menu.orders',
                    url: '/community/order',
                  },
                ],
              },
              {
                index: 7,
                label: 'menu.logout',
                icon: '/assets/icons/' + (mobile ? 'mobile/' : '') + 'Icon-Logout-Nav.svg',
                url: '#',
                action: 'LOGOUT',
              },
            ]);
          }
        });
      });
    });
  }
}
